import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import loginImg from "../images/loginimg.jpg";
import { loginUser } from "../api/authApi";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ emailOrPhone: "", password: "" });
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const data = await loginUser(form);

      localStorage.setItem("user", JSON.stringify(data));
      localStorage.setItem("token", data.token);
localStorage.setItem("user", JSON.stringify(data.user));
localStorage.setItem("role", data.user.role);
      navigate("/");

    } catch (err) {
      const message = err.response?.data?.message;

      if (message === "Please verify your account first") {
        // save email for verification
        localStorage.setItem("verifyEmail", form.emailOrPhone);

        navigate("/verify-otp", { state: { flow: "register" } });
      } else {
        setError(message || "Login failed");
      }
    }
  };

  return (
    <div className="h-screen overflow-hidden grid grid-cols-1 md:grid-cols-2 bg-[#f4ede4]">
      {/* LEFT IMAGE */}
      <div className="hidden md:block">
        <img src={loginImg} alt="Login" className="h-full w-full object-cover" />
      </div>

      {/* RIGHT FORM */}
      <div className="flex items-center justify-center px-6">
        <div className="w-full max-w-md mt-[-50px]">
          <h1 className="text-5xl font-semibold mb-6">Welcome</h1>

          {error && <p className="text-red-500 mb-4">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-5">
            <input
              type="text"
              name="emailOrPhone"
              placeholder="Email or Phone"
              value={form.emailOrPhone}
              onChange={handleChange}
              className="w-full border-b bg-transparent py-3 focus:outline-none"
              required
            />
            <div className="relative w-full">

              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
                className="w-full border-b bg-transparent py-3 pr-10 
               focus:outline-none"
                required
              />

              {/* Eye Icon */}
              <div
                className="absolute right-0 top-1/2 -translate-y-1/2 
               cursor-pointer text-gray-500"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FiEye size={20} /> : <FiEyeOff size={20} />}
              </div>

            </div>

            <div className="flex justify-end mt-1">
              <Link
                to="/forgot-password"
                className="text-sm text-blue-600 hover:underline"
              >
                Forgot Password?
              </Link>
            </div>
            <button className="w-full bg-black text-white py-3 rounded-full mt-6 hover:opacity-90 transition">
              SIGN IN
            </button>
          </form>

          <p className="text-lg mt-6">
            Don’t have an account?{" "}
            <Link to="/register" className="underline">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
